module.exports = __webpack_public_path__ + "media/images/product/f_g-1bb606fb5b6e0558bb14a275d968168e.png";